@if (deviceInformations) {
<div class="device-container">
    <div class="title">
        <fa-icon [icon]="faAngleRight"></fa-icon>
        <span>
            {{ 'Device.Title' | translate }}
            {{ deviceInformations.name ? '"' + deviceInformations.name + '"' : deviceInformations.address ? '"' + deviceInformations.address + '"' : '' }}
        </span>
    </div>

    <div class="content">
        <mat-tab-group>
            <mat-tab label="Général">
                @if (deviceInformations !== undefined) {
                <form [formGroup]="deviceForm" (ngSubmit)="onSubmit()">
                    <mat-card appearance="outlined" class="box default-card">
                        <mat-card-content>
                            <div class="card-content">
                                <mat-card appearance="outlined">
                                    <mat-card-header>
                                        <mat-card-title class="card-title">{{ 'Device.IdentityTitle' | translate }}</mat-card-title>
                                    </mat-card-header>
                                    <mat-card-content>
                                        <div class="input-content">
                                            <div>
                                                <mat-form-field>
                                                    <mat-label>{{ 'Device.NamePlaceholder' | translate }}</mat-label>
                                                    <input matInput formControlName="name" name="name" autocomplete="off" required />
                                                </mat-form-field>
                                            </div>
                                            <div>
                                                <mat-form-field>
                                                    <mat-label>{{ 'Device.AddressPlaceholder' | translate }}</mat-label>
                                                    <input matInput formControlName="address" autocomplete="off" [readonly]="!isCreation" required />
                                                    <mat-error>{{ 'Device.AddressError' | translate }}</mat-error>
                                                </mat-form-field>
                                            </div>
                                            <div>
                                                <mat-form-field>
                                                    <mat-label>{{ 'Device.PasswordPlaceholder' | translate }}</mat-label>
                                                    <input
                                                        [type]="hide ? 'password' : 'text'"
                                                        matInput
                                                        formControlName="password"
                                                        name="password"
                                                        autocomplete="new-password"
                                                        required />
                                                    <button
                                                        mat-icon-button
                                                        matSuffix
                                                        (click)="hide = !hide"
                                                        [attr.aria-label]="'Hide password'"
                                                        [attr.aria-pressed]="hide"
                                                        type="button">
                                                        <mat-icon>{{ hide ? 'visibility_off' : 'visibility' }}</mat-icon>
                                                    </button>
                                                </mat-form-field>
                                            </div>
                                            <div>
                                                <mat-form-field>
                                                    <mat-label>{{ 'Device.ModelNamePlaceholder' | translate }}</mat-label>
                                                    <input type="text" matInput [matAutocomplete]="auto" formControlName="deviceModel" [readonly]="!isCreation" required />
                                                    <mat-autocomplete
                                                        autoActiveFirstOption
                                                        #auto="matAutocomplete"
                                                        [displayWith]="displayDeviceModel"
                                                        (optionSelected)="deviceModelSelectionChange($event)">
                                                        @for (model of filteredDevicesModels | async; track model) {
                                                        <mat-option [value]="model">
                                                            {{ model | deviceModelDisplay }}
                                                        </mat-option>
                                                        }
                                                    </mat-autocomplete>
                                                </mat-form-field>
                                            </div>
                                            <div>
                                                <mat-form-field>
                                                    <mat-label>{{ 'Device.CodecsPlaceholder' | translate }}</mat-label>
                                                    <mat-select formControlName="codecs" multiple (valueChange)="selectedCodecsChange($event)">
                                                        <mat-select-trigger>
                                                            @if (deviceForm.get('codecs').value) {
                                                            <mat-chip-listbox cdkDropList cdkDropListOrientation="horizontal" (cdkDropListDropped)="drop($event)">
                                                                @for (codecSelected of selectedCodecs; track codecSelected) {
                                                                <mat-chip-option cdkDrag>{{ codecSelected }}</mat-chip-option>
                                                                }
                                                            </mat-chip-listbox>
                                                            }
                                                        </mat-select-trigger>
                                                        @for (codecs of selectedDeviceModel?.codecs; track codecs) {
                                                        <mat-option [value]="codecs">
                                                            {{ codecs }}
                                                        </mat-option>
                                                        }
                                                    </mat-select>
                                                </mat-form-field>
                                            </div>
                                        </div>
                                    </mat-card-content>
                                </mat-card>

                                <mat-card style="width: 100%" appearance="outlined">
                                    <mat-card-header>
                                        <mat-card-title class="card-title">{{ 'Device.RelatedExtensionsTitle' | translate }}</mat-card-title>
                                    </mat-card-header>
                                    <mat-card-content>
                                        <div class="input-content">
                                            <div>
                                                <mat-form-field>
                                                    <mat-label>{{ 'Device.ExtensionsPlaceholder' | translate }}</mat-label>
                                                    <input
                                                        type="text"
                                                        matInput
                                                        [matAutocomplete]="autoextensions"
                                                        formControlName="filterExtensions"
                                                        (focusin)="deviceForm.get('filterExtensions').setValue('')" />
                                                </mat-form-field>

                                                <mat-autocomplete
                                                    autoActiveFirstOption
                                                    class="autocomplete-multiple-selection"
                                                    #autoextensions="matAutocomplete"
                                                    [displayWith]="displayExtension"
                                                    hideSingleSelectionIndicator="true">
                                                    @for (extension of filteredExtensions | async; track extension.id) {
                                                    <mat-option [value]="extension.id">
                                                        <div style="white-space: nowrap">
                                                            <mat-checkbox (change)="toggleSelection(extension)" [checked]="extension.isSelected" (click)="$event.stopPropagation()">
                                                                <mat-icon [class]="extension.registrationState === 'registered' ? 'color-registered' : 'color-unregistered'">
                                                                    @if (extension.type === 'device') { tty } @if (extension.type === 'user') { person } @if (extension.type ===
                                                                    'group') { group } @if (extension.type === 'service') { settings } @if (extension.type === 'queue') { call_split
                                                                    }
                                                                </mat-icon>
                                                                {{ extension.name }} ({{ extension.number }})
                                                            </mat-checkbox>
                                                        </div>
                                                    </mat-option>
                                                    }
                                                </mat-autocomplete>

                                                <mat-list class="extension-list">
                                                    @for (extension of selectedExtensions; track extension) {
                                                    <mat-list-item>
                                                        <mat-icon
                                                            matListItemIcon
                                                            [class]="extension.registrationState === 'registered' ? 'color-registered' : 'color-unregistered'">
                                                            @if (extension.type === 'device') { tty } @if (extension.type === 'user') { person } @if (extension.type === 'group') {
                                                            group } @if (extension.type === 'service') { settings } @if (extension.type === 'queue') { call_split }
                                                        </mat-icon>
                                                        <div matListItemTitle>{{ extension.name }} ({{ extension.number }})</div>
                                                        @if (extension.type !== extensionTypes.device) {
                                                        <div matListItemMeta class="action-button">
                                                            <button mat-icon-button (click)="deleteExtension(extension)">
                                                                <mat-icon>delete</mat-icon>
                                                            </button>
                                                        </div>
                                                        }
                                                    </mat-list-item>
                                                    }
                                                </mat-list>
                                            </div>
                                        </div>
                                    </mat-card-content>
                                </mat-card>

                                <mat-card style="width: 100%" appearance="outlined">
                                    <mat-card-header>
                                        <mat-card-title class="card-title">{{ 'Device.ConfigurationTitle' | translate }}</mat-card-title>
                                    </mat-card-header>
                                    <mat-card-content>
                                        <div class="input-content">
                                            <div>
                                                <mat-form-field>
                                                    <mat-label>{{ 'Device.vlanIdPlaceholder' | translate }}</mat-label>
                                                    <input matInput type="number" min="0" max="4094" formControlName="vlanId" autocomplete="off" />
                                                </mat-form-field>
                                            </div>
                                            <div>
                                                <mat-form-field>
                                                    <mat-label>{{ 'Device.RportPlaceholder' | translate }}</mat-label>
                                                    <mat-select formControlName="rport">
                                                        <mat-option [value]="0">{{ 'Device.RportDisabled' | translate }} (0)</mat-option>
                                                        <mat-option [value]="1">{{ 'Device.RportEnabled' | translate }} (1)</mat-option>
                                                        <mat-option [value]="2">{{ 'Device.RportActivateDirectProcess' | translate }} (2)</mat-option>
                                                    </mat-select>
                                                </mat-form-field>
                                            </div>
                                            <div>
                                                <mat-checkbox formControlName="stun"></mat-checkbox>
                                                <mat-label>{{ 'Device.StunPlaceholder' | translate }}</mat-label>
                                            </div>
                                            <div>
                                                <mat-form-field>
                                                    <input matInput formControlName="stunServer" autocomplete="off" />
                                                    <mat-label>{{ 'Device.StunServerPlaceholder' | translate }}</mat-label>
                                                </mat-form-field>
                                            </div>
                                            <div>
                                                <mat-form-field>
                                                    <input matInput type="number" formControlName="stunPort" autocomplete="off" />
                                                    <mat-label>{{ 'Device.StunPortPlaceholder' | translate }}</mat-label>
                                                </mat-form-field>
                                            </div>
                                        </div>
                                    </mat-card-content>
                                </mat-card>

                                @if (!isCreation) {
                                <mat-card style="width: 100%" appearance="outlined">
                                    <mat-card-header>
                                        <mat-card-title class="card-title">{{ 'Device.StateAndStatusTitle' | translate }}</mat-card-title>
                                    </mat-card-header>
                                    <mat-card-content>
                                        <div class="input-content">
                                            <div>
                                                <mat-form-field>
                                                    <mat-label>{{ 'Device.StatePlaceholder' | translate }}</mat-label>
                                                    <input matInput value="{{ 'EnumRegistrationStates.' + deviceInformations.state | translate }}" autocomplete="off" readonly />
                                                    @if (deviceInformations.state === registrationStates.registered) {
                                                    <mat-icon matSuffix class="color-registered">check_circle</mat-icon>
                                                    } @if (deviceInformations.state === registrationStates.unregistered) {
                                                    <mat-icon matSuffix class="color-unregistered">cancel</mat-icon>
                                                    } @if (deviceInformations.state === registrationStates.undefined) {
                                                    <mat-icon matSuffix class="color-undefined">remove_circle</mat-icon>
                                                    }
                                                </mat-form-field>
                                            </div>
                                            <div>
                                                <mat-form-field>
                                                    <mat-label>{{ 'Device.RegistrationDatePlaceholder' | translate }}date d'enregistrement</mat-label>
                                                    <input matInput value="{{ deviceInformations.registrationTime | translateDate : 'short' }}" autocomplete="off" readonly />
                                                </mat-form-field>
                                            </div>
                                            <div>
                                                <mat-form-field>
                                                    <mat-label>{{ 'Device.UnregistrationDatePlaceholder' | translate }}</mat-label>
                                                    <input matInput value="{{ deviceInformations.unregistrationTime | translateDate : 'short' }}" autocomplete="off" readonly />
                                                </mat-form-field>
                                            </div>
                                            <div>
                                                <mat-form-field>
                                                    <mat-label>{{ 'Device.PublicAddressPlaceholder' | translate }}</mat-label>
                                                    <input matInput value="{{ deviceInformations.publicAddress }}" autocomplete="off" readonly />
                                                </mat-form-field>
                                            </div>
                                            <div>
                                                <mat-form-field class="form-field">
                                                    <mat-label>{{ 'Device.PrivateAddressPlaceholder' | translate }}</mat-label>
                                                    <input matInput value="{{ deviceInformations.privateAddress }}" autocomplete="off" readonly />
                                                </mat-form-field>
                                            </div>
                                        </div>
                                    </mat-card-content>
                                </mat-card>
                                }
                            </div>
                        </mat-card-content>
                    </mat-card>
                </form>
                }
            </mat-tab>
            @if (deviceInformations.manufacturer && blfsTypes.length > 0) {
            <mat-tab label="BLFs">
                <app-blfs [blfsTypes]="blfsTypes" [blfs]="deviceInformations.blfs"></app-blfs>
            </mat-tab>
            <mat-tab label="Extenders">
                <app-blfs [blfsTypes]="blfsTypes" [blfs]="deviceInformations.extenders" [isExtenders]="true"></app-blfs>
            </mat-tab>
            }
        </mat-tab-group>

        <div class="save-button">
            <button mat-stroked-button type="button" color="accent" routerLink="/devices">
                {{ 'Device.CancelButton' | translate }}
            </button>
            <button mat-raised-button color="accent" [disabled]="!deviceForm.valid" (click)="onSubmit()">
                {{ 'Device.SubmitButton' | translate }}
            </button>
        </div>
    </div>
</div>
}
